import {Component, EventEmitter, Output} from '@angular/core';
import {FormBaseComponent, ValidatorService} from '@utils-lib';
import {Plattform} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'common-ui-plattform',
  templateUrl: './plattform.component.html',
  styleUrls: ['./plattform.component.scss']
})
export class PlattformComponent extends FormBaseComponent<Plattform> {

  @Output()
  removePlattformClicked = new EventEmitter<number>();

  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              protected readonly messageService: DatevMessageService,
              protected readonly translateService: TranslateService) {
    super(messageService);
  }

  public removePlattform(): void {
    this.removePlattformClicked.emit(this.index);
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({
      name: [this.data.name, [
        this.validatorService.required(),
        this.validatorService.maxLength(100)
      ]],
      accountName: [this.data.accountName, [
        this.validatorService.maxLength(100)
      ]]
    });
  }
}

